import { z } from 'zod';
import { currencySchema, moneySchema, periodSchema, agreementsSchema, requestIdSchema, timestampSchema, preLimitIdSchema, limitIdSchema, loanIdSchema, representativeIdSchema, ibanIdSchema, offerIdSchema, loanResponseStatus, providerType, loanProviderRequest, loanStage, } from '@repo/shared/types';
import { internalErrorResponseSchema, loanDataNotFoundResponseSchema, loanResponseBaseSchema, redisKeyNotFoundResponseSchema, } from './loan-shared.schema';
export var loanRequestBodySchema = z.object({
    requestId: requestIdSchema,
    data: z.object({
        preLimitId: preLimitIdSchema,
        limitId: limitIdSchema.nullable(),
        source: z.string(),
        agreements: agreementsSchema,
        loan: z.object({
            representativeId: representativeIdSchema,
            ibanId: ibanIdSchema,
            amount: moneySchema,
            currency: currencySchema,
            period: periodSchema,
            pricing: moneySchema,
            loanRepaymentPrice: moneySchema,
            name: z.string(),
            provider: providerType,
            code: z.string().nullable(),
        }),
        offerId: offerIdSchema.nullable(),
    }),
});
// Response code 200
export var loanAddResponseSchema = z
    .object({
    data: z.object({
        loanId: loanIdSchema,
        status: loanResponseStatus,
        providerRequest: loanProviderRequest,
        stage: loanStage,
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 400
export var loanAddRedisKeyNotFoundResponseSchema = redisKeyNotFoundResponseSchema;
// Response code 400
export var amountToBigForLoanResponseSchema = z
    .object({
    data: z.object({
        parameter: z.string(),
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 404
export var loanAddDataNotFoundResponseSchema = loanDataNotFoundResponseSchema;
// Response code 404
export var loanPrelimitNotFoundResponseSchema = z
    .object({
    data: z.object({
        parameter: z.string(),
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 409
export var unfinishedLoanProcessResponseSchema = z
    .object({
    data: z.object({
        parameter: z.string(),
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 500
export var loanAddInternalErrorResponseSchema = internalErrorResponseSchema;
// Revenue rate item shared shape (mirrors discount-validate)
var loan422RevenueRateItemSchema = z.object({
    period: periodSchema,
    pricing: moneySchema,
    loanRepaymentPrice: moneySchema,
    amountMax: moneySchema.nullable(),
    amountMin: moneySchema.nullable(),
});
// Response code 422 - discount code soft error
export var loanAdd422ResponseSchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: z.literal('LOAN'),
    data: z.object({
        parameter: z.string(),
        reasonCode: z.string(),
        reason: z.string(),
        availableRevenueRate: z
            .object({
            original: loan422RevenueRateItemSchema,
            discounted: loan422RevenueRateItemSchema,
        })
            .nullable()
            .optional(),
    }),
});
